export const eventsConstants = {
  CONTENT_IFRAME_STARTED: 'content.iframe.started',
  CONTENT_IFRAME_MEDIA_REQUESTED: 'content.iframe.media.requested',
  CONTENT_IFRAME_FINISHED: 'content.iframe.finished',
  CONTENT_VIDEO_STARTED: 'content.video.started',
  CONTENT_VIDEO_MEDIA_REQUESTED: 'content.video.media.requested',
  CONTENT_VIDEO_FINISHED: 'content.video.finished',
  CONTENT_QUIZ_STARTED: 'content.quiz.started',
  CONTENT_QUIZ_FINISHED: 'content.quiz.finished',
  CONTENT_COURSE_ACTIVE_ADDED: 'content.course.active.added',
  CONTENT_COURSE_ACTIVE_REMOVED: 'content.course.active.removed',
  CONTENT_EXERCISE_SUBMITTED: 'content.exercise.submitted',
  CONTENT_EXERCISE_FINISHED: 'content.exercise.finished',
  CONTENT_ELS_LAB_STARTED: 'content.els_lab.started',
  CONTENT_ELS_LAB_STOPPED: 'content.els_lab.stopped',
  CONTENT_ELS_LAB_ERROR: 'content.els_lab.error',
  CONTENT_LAB_STARTED: 'content.lab.started',
  CONTENT_LAB_FINISHED: 'content.lab.started',
  CONTENT_ISSUE_SENT: 'content.issue.sent',
  CONTENT_RATING_SENT: 'content.rating.sent',

  SUBSCRIPTION_PAYMENT_UPDATED: 'subscription.payment.updated',
  SUBSCRIPTION_PAYMENT_RECURLY_ERROR:
    'subscription.payment.update.recurly.error',
  SUBSCRIPTION_PAYMENT_UPDATE_ERROR: 'subscription.payment.update.error',
  SUBSCRIPTION_SUBSCRIPTION_CANCELLED: 'subscription.subscription.cancelled',
  SUBSCRIPTION_SUBSCRIPTION_REACTIVATED:
    'subscription.subscription.reactivated',
  SUBSCRIPTION_SUBSCRIPTION_EXTENDED: 'subscription.subscription.extended',
  SUBSCRIPTION_INVOICES_DOWNLOADED: 'subscription.invoices.downloaded',

  ACCOUNT_USER_LOGIN: 'account.user.login',
}

export const eventsList = {
  [eventsConstants.CONTENT_IFRAME_STARTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'iframe_id',
    'iframe_name',
    'type',
  ],
  [eventsConstants.CONTENT_IFRAME_MEDIA_REQUESTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'iframe_id',
    'iframe_name',
    'type',
  ],
  [eventsConstants.CONTENT_IFRAME_FINISHED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'iframe_id',
    'iframe_name',
    'type',
  ],
  [eventsConstants.CONTENT_VIDEO_STARTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'video_id',
    'video_name',
    'type',
  ],
  [eventsConstants.CONTENT_VIDEO_MEDIA_REQUESTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'video_id',
    'video_name',
    'type',
    'trigger',
  ],
  [eventsConstants.CONTENT_VIDEO_FINISHED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'video_id',
    'video_name',
    'type',
  ],
  [eventsConstants.CONTENT_QUIZ_STARTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'quiz_id',
  ],
  [eventsConstants.CONTENT_QUIZ_FINISHED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'quiz_id',
  ],
  [eventsConstants.CONTENT_COURSE_ACTIVE_ADDED]: [
    'course_id',
    'course_name',
    'trigger',
  ],
  [eventsConstants.CONTENT_COURSE_ACTIVE_REMOVED]: [
    'course_id',
    'course_name',
    'trigger',
  ],
  [eventsConstants.CONTENT_EXERCISE_SUBMITTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'exercise_id',
    'exercise_name',
  ],
  [eventsConstants.CONTENT_EXERCISE_FINISHED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'exercise_id',
    'exercise_name',
  ],
  [eventsConstants.CONTENT_ELS_LAB_STARTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'lab_id',
    'lab_name',
    'type',
  ],
  [eventsConstants.CONTENT_ELS_LAB_STOPPED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'lab_id',
    'lab_name',
    'type',
  ],
  [eventsConstants.CONTENT_ELS_LAB_ERROR]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'lab_id',
    'lab_name',
    'error_code',
    'type',
  ],
  [eventsConstants.CONTENT_LAB_STARTED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'lab_id',
    'lab_name',
    'type',
  ],
  [eventsConstants.CONTENT_LAB_FINISHED]: [
    'course_id',
    'course_name',
    'learning_path_id',
    'learning_path_name',
    'bootcamp_id',
    'bootcamp_name',
    'lab_id',
    'lab_name',
    'type',
  ],
  [eventsConstants.CONTENT_ISSUE_SENT]: [
    'course_id',
    'content_subtype',
    'content_type',
    'content_id',
    'subject',
  ],
  [eventsConstants.CONTENT_RATING_SENT]: [
    'course_id',
    'course_name',
    'instructor_id',
    'instructor_name',
    'confirmed',
  ],

  [eventsConstants.SUBSCRIPTION_PAYMENT_UPDATED]: [],
  [eventsConstants.SUBSCRIPTION_PAYMENT_RECURLY_ERROR]: ['error_fields'],
  [eventsConstants.SUBSCRIPTION_PAYMENT_UPDATE_ERROR]: [],
  [eventsConstants.SUBSCRIPTION_SUBSCRIPTION_CANCELLED]: ['subscription_id'],
  [eventsConstants.SUBSCRIPTION_SUBSCRIPTION_REACTIVATED]: ['subscription_id'],
  [eventsConstants.SUBSCRIPTION_SUBSCRIPTION_EXTENDED]: ['subscription_id'],
  [eventsConstants.SUBSCRIPTION_INVOICES_DOWNLOADED]: [],

  [eventsConstants.ACCOUNT_USER_LOGIN]: 'account.user.login',
}
